import { readString } from "react-papaparse";

export type ParsedReportCsv = {
  columns: string[];
  rows: string[][];
};

export const parseReportCsv = (csvContent: string): ParsedReportCsv => {
  let parsedCsv: ParsedReportCsv = { columns: [], rows: [] };

  // String parsing is synchronous. Keep every cell as text so identifiers,
  // leading zeroes, and the backend's formatted values remain unchanged.
  readString<string[]>(csvContent, {
    delimiter: ",",
    dynamicTyping: false,
    header: false,
    skipEmptyLines: true,
    complete: ({ data, errors }) => {
      if (errors.length > 0) {
        throw new Error("The report CSV could not be read.");
      }

      const [columns = [], ...rows] = data;
      parsedCsv = { columns, rows };
    },
  });

  return parsedCsv;
};
